import { Send, Mic, X, Check } from "lucide-react";
import React, { useState, useRef, useEffect } from "react";
import useIsDesktop from "../hooks/useIsDesktop";
import { useVoiceRecorder } from "../hooks/useVoiceRecorder";
import VoiceWaveform from "./ui/VoiceWaveform";

function ChatInput({ onSend, placeholder, focus, chatEnabled }) {
  const textareaRef = useRef(null);

  const [text, setText] = useState("");

  const isDesktop = useIsDesktop();

  const { recording, transcribing, stream, startRecording, confirmRecording, cancelRecording } =
    useVoiceRecorder((transcript) => setText(transcript));

  const loading = transcribing;

  const send = () => {
    if (!chatEnabled) return;
    if (!text.trim()) return;
    onSend(text.trim());
    setText("");
  };

  const handleKeyDown = (e) => {
    if (e.key === "Enter" && !e.shiftKey) {
      e.preventDefault();
      send();
    }
  };

  useEffect(() => {
    const textarea = textareaRef.current;
    if (textarea) {
      textarea.style.height = "auto";
      textarea.style.height = textarea.scrollHeight + "px";
    }
  }, [text]);

  useEffect(() => {
    if (isDesktop) {
      textareaRef.current?.focus();
    }
  }, [focus]);

  return (
    <div className="bg-gray-800 rounded-2xl shadow-lg overflow-hidden">
      <div className="flex w-full items-center">
        {recording ? 
          (<VoiceWaveform isRecording={recording} stream={stream} />)
          :
          (<textarea
            ref={textareaRef}
            rows={1}
            value={loading ? "⏳ Transcription en cours..." : text}
            placeholder={placeholder}
            disabled={loading}
            className="flex-1 bg-transparent resize-none p-4 outline-none placeholder-custom-500"
            onChange={(e) => setText(e.target.value)}
            onKeyDown={handleKeyDown}
          />)
        }
        {/* 🎤 Bouton dictaphone */}
        {!recording ? (
          <button
            onClick={startRecording}
            disabled={loading}
            className='p-2 mr-2  rounded-full transition'
            title="Dicter"
          >
            <Mic size={20} />
          </button>
        ) : (
          <button
            onClick={cancelRecording}
            disabled={loading}
            className='p-2 mr-2  rounded-full transition'
            title="Annuler"
          >
            <X size={18} />
          </button>
        )}

        {/* 📤 Bouton envoyer */}
        {!recording ? (
          <button
            onClick={send}
            disabled={loading}
            className="p-4 border-l border-gray-700 transition"
            title="Envoyer"
          >
            <Send size={20} />
          </button>
        ) : (
          <button
            onClick={confirmRecording}
            disabled={loading}
            className="p-4 border-l border-gray-700 transition"
            title="Valider"
          >
            <Check size={18} />
          </button>
        )}
      </div>
    </div>
  );
}

export default ChatInput;
